import { ErrorType, errorTypeByErrorMessage } from '@settings/constants';

export const getErrorTypeByMessage = (message: string): ErrorType => {
  return errorTypeByErrorMessage?.[
    Object.keys(errorTypeByErrorMessage).find((errorType) => message.includes(errorType))
  ];
};
